import Vue from 'vue'
import Vuex, { StoreOptions } from 'vuex'
import Connection from '@/api/models/Connection'
import Account from '@/api/models/Account'
import { actions } from '@/store/actions'
import { mutations } from '@/store/mutations'
import { getters } from '@/store/getters'
import { Status } from '@/api/models/Status'
import { ProductProperty } from '@/models/ProductProperty';

Vue.use(Vuex)

export interface State {
    loading: boolean;
    connection: Connection;
    accounts: Array<Account>;
    currentAccountId: number;
    systemStatuses: Array<Status>;
    systemProductStatuses: Array<Status>;
    systemPaymentStatuses: Array<Status>;
    cdekStatuses: Array<Status>;
    productProperties: Array<ProductProperty>;
}

const rootState: State = {
    loading: false,
    connection: {
        crmUrl: '',
        crmToken: '',
        isActive: false,
        accounts: []
    },
    currentAccountId: 0,
    accounts: [],
    systemStatuses: [],
    systemProductStatuses: [],
    systemPaymentStatuses: [],
    cdekStatuses: [],
    productProperties: []
}

const store: StoreOptions<State> = {
    state: rootState,
    mutations,
    actions,
    getters
}

export default new Vuex.Store<State>(store)
